import {
  type GenericMappingByKey,
  GenericMappingType,
} from '../../search/types'
import { getGenericMappingArrayFromGenericMappingByKey } from './utils'

export const JIRA_GENERIC_MAPPINGS_BY_KEY = Object.freeze({
  project: {
    type: GenericMappingType.KEYWORD,
    name: 'Project',
    description: 'Project the issue belongs to',
    enumFromCollapseEsQuery: true,
    order: 0,
  },
  dueDate: {
    type: GenericMappingType.DATE,
    name: 'Due date',
    description: 'Expected date of resolution for the issue',
    order: 1,
  },
  assignee: {
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'Assignee responsible of the issue',
    enumFromCollapseEsQuery: true,
    order: 2,
  },
  reporter: {
    type: GenericMappingType.KEYWORD,
    name: 'Reporter',
    description: 'User who reported the issue',
    enumFromCollapseEsQuery: true,
    order: 3,
  },
  priority: {
    type: GenericMappingType.KEYWORD,
    name: 'Priority',
    description: 'Priority issue',
    enumFromCollapseEsQuery: true,
    order: 4,
  },
  status: {
    type: GenericMappingType.KEYWORD,
    name: 'Status',
    description: 'Status of the issue',
    enumFromCollapseEsQuery: true,
    order: 5,
  },
  resolution: {
    type: GenericMappingType.KEYWORD,
    name: 'Resolution',
    description: 'Contains explanation about how the issue was resolved',
    order: 6,
  },
  type: {
    type: GenericMappingType.KEYWORD,
    name: 'Type',
    description: 'Type of the issue',
    enumFromCollapseEsQuery: true,
    order: 7,
  },
  creator: {
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'Creator of the issue',
    enumFromCollapseEsQuery: true,
    order: 8,
  },
  key: {
    type: GenericMappingType.KEYWORD,
    name: 'Identifier',
    description: 'Human readable issue identifier',
    order: 9,
  },
  labels: {
    type: GenericMappingType.KEYWORD,
    name: 'Labels',
    description: 'Labels set on the issue',
    enumFromTermsAggEsQuery: true,
    order: 10,
  },
  percentProgress: {
    type: GenericMappingType.NUMBER,
    name: 'Progress in percent',
    description: 'Completion progress of the issue in percent',
    order: 11,
  },
  resolutionDate: {
    type: GenericMappingType.DATE,
    name: 'Resolution date',
    description: 'Date when the issue was resolved',
    order: 12,
  },
  timeSpent: {
    type: GenericMappingType.NUMBER,
    name: 'Time spent',
    description: 'Time spent on the issue',
    order: 13,
  },
} satisfies GenericMappingByKey)

export const JIRA_GENERIC_MAPPINGS =
  getGenericMappingArrayFromGenericMappingByKey(JIRA_GENERIC_MAPPINGS_BY_KEY)
